import baseEditForm from 'formiojs/components/button/Button.form';
export default baseEditForm;
